import {
  CheckCircle2,
  XCircle,
  Loader2,
  CalendarClock,
} from "@/components/icons";

export default function PendingActions({
  acting,
  onConfirm,
  onReschedule,
  onDecline,
  actionResult,
}) {
  return (
    <div className="mt-7">
      {actionResult?.state === "rescheduled" ? (
        <div
          data-testid="reschedule-success-banner"
          className="mb-4 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-emerald-200 text-emerald-800 text-xs font-bold w-full justify-center"
        >
          <CheckCircle2 className="w-3.5 h-3.5" />
          ¡Cita reprogramada! Confirma la nueva fecha cuando estés listo.
        </div>
      ) : null}

      <p className="text-center text-sm text-black/70 mb-3">¿Podrás asistir?</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <button
          type="button"
          data-testid="confirm-attend-btn"
          onClick={onConfirm}
          disabled={acting}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-[#01BC8E] hover:bg-[#01BC8E] disabled:opacity-60 text-white font-bold text-sm transition"
        >
          {acting ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />}
          Confirmar asistencia
        </button>
        <button
          type="button"
          data-testid="reschedule-mode-btn"
          onClick={onReschedule}
          disabled={acting}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-white hover:bg-black/[0.04] disabled:opacity-60 text-black font-bold text-sm border border-[#E5E7EB] transition"
        >
          <CalendarClock className="w-4 h-4" />
          Reprogramar
        </button>
        <button
          type="button"
          data-testid="decline-attend-btn"
          onClick={onDecline}
          disabled={acting}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-white hover:bg-black/[0.04] disabled:opacity-60 text-black font-bold text-sm border border-[#E5E7EB] transition"
        >
          <XCircle className="w-4 h-4" />
          No podré asistir
        </button>
      </div>
      {actionResult?.error ? (
        <p
          className="mt-3 text-center text-sm text-red-700"
          data-testid="confirm-action-error"
        >
          {actionResult.error}
        </p>
      ) : null}
    </div>
  );
}
